import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import EditUserForm from './EditUserForm';

const EditUserDialog = ({ open, onOpenChange, user, onUpdateUser, isTransporter }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (userData) => {
    setIsSubmitting(true);
    try {
      await onUpdateUser(userData);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[650px]">
        <DialogHeader>
          <DialogTitle>{isTransporter ? 'Edit Driver' : 'Edit User'}</DialogTitle>
        </DialogHeader>
        <EditUserForm 
          user={user}
          onUpdateUser={handleSubmit} 
          onCancel={() => onOpenChange(false)} 
          isTransporter={isTransporter}
          isSubmitting={isSubmitting}
        />
      </DialogContent>
    </Dialog>
  );
};

export default EditUserDialog;